import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Handles two common SPA scroll behaviours:
 *   1. Scroll to top on pure path change (no hash).
 *   2. Scroll to the element referenced by location.hash after the page renders.
 */
export default function ScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Wait a tick for the target section to render, then scroll into view
      const id = hash.replace("#", "");
      let attempts = 0;
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }
        if (attempts++ < 20) setTimeout(tryScroll, 60);
      };
      tryScroll();
      return;
    }
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, hash]);

  return null;
}
